import { classifyTradeOutcomeByThreshold } from "../statsUtils";

const UNCLASSIFIED_VALUES = new Set(["", "n/a", "na", "not applicable"]);

function normalizeClassification(value) {
  const label = String(value || "").trim().replace(/\s+/g, " ");
  return {
    key: label.toLowerCase(),
    label,
  };
}

export function computeAvoidableLossAnalytics(trades = [], beThreshold) {
  const losingTrades = trades.filter(
    (trade) => classifyTradeOutcomeByThreshold(trade?.pnl, beThreshold) === "loss"
  );
  const categories = new Map();
  let totalLossDollars = 0;
  let avoidableLossDollars = 0;
  let classifiedLosingTradeCount = 0;
  let avoidableTradeCount = 0;

  losingTrades.forEach((trade) => {
    const lossDollars = Math.abs(Number(trade.pnl) || 0);
    totalLossDollars += lossDollars;

    const classification = normalizeClassification(trade.lossClassification);
    if (UNCLASSIFIED_VALUES.has(classification.key)) return;

    classifiedLosingTradeCount += 1;
    if (classification.key === "valid loss") return;

    avoidableTradeCount += 1;
    avoidableLossDollars += lossDollars;
    const current = categories.get(classification.key) || {
      classification: classification.label,
      tradeCount: 0,
      lossDollars: 0,
    };
    current.tradeCount += 1;
    current.lossDollars += lossDollars;
    categories.set(classification.key, current);
  });

  const categoryBreakdown = [...categories.values()]
    .map((category) => ({
      ...category,
      shareOfAvoidable: avoidableLossDollars > 0
        ? (category.lossDollars / avoidableLossDollars) * 100
        : 0,
    }))
    .sort((a, b) => b.lossDollars - a.lossDollars || b.tradeCount - a.tradeCount);

  return {
    losingTradeCount: losingTrades.length,
    classifiedLosingTradeCount,
    avoidableTradeCount,
    totalLossDollars,
    avoidableLossDollars,
    avoidableLossPercentage: totalLossDollars > 0
      ? (avoidableLossDollars / totalLossDollars) * 100
      : 0,
    classificationCoveragePercentage: losingTrades.length > 0
      ? (classifiedLosingTradeCount / losingTrades.length) * 100
      : 0,
    categories: categoryBreakdown,
  };
}
